import { PropTypes } from 'prop-types'
import React from 'react'
import settings from 'settings'


const propTypes = {
  licenseCount: PropTypes.number,
}
const defaultProps = {
  licenseCount: 0,
}


const AvailableLicenses = ({ licenseCount }) => (
  <div className="uk-card uk-card-default uk-card-body" style={{ maxWidth: 750 }}>
    <div className="uk-margin">
      You have
      &nbsp;
      <span className="uk-text-large uk-text-bold">
        {licenseCount}
      </span>
      {licenseCount === 1 ? ' license' : ' licenses'}
      &nbsp;available.
    </div>
    <div className="uk-margin">
      <a
        href={`${settings.urls.www}/contact`}
        target="_blank"
        rel="noopener noreferrer"
      >
        <div className="uk-button uk-button-primary tm-button-primary">
          Add Licenses
        </div>
      </a>
    </div>
  </div>
)


AvailableLicenses.propTypes = propTypes
AvailableLicenses.defaultProps = defaultProps

export default AvailableLicenses
